import React from "react";
import styles from "./portfolioCompareTableBar.module.scss";
import { useTranslation } from "react-i18next";
import { formatItalianNumber } from "utils/formatUtils";
import { useComparisonLabels } from "../ComparisonLabelsContext";

const FinecoTableCompare = ({ dataObject, dataObject2 }) => {
  const { t } = useTranslation();
  const labels = useComparisonLabels();

  if (!dataObject.data || !dataObject2?.data) {
    return null;
  }

  const total1 = Math.round(
    dataObject.data.reduce((sum, row) => sum + row.weight, 0),
  );

  const total2 = Math.round(
    dataObject2.data.reduce((sum, row) => sum + row.weight, 0),
  );

  return (
    <div className={styles.tableContainer}>
      {/* Positioned Peso label */}
      <div className={styles.pesoCellHeader}>
        <span>{dataObject.configData.label_table_right}</span>
      </div>

      <table className={styles.distributionTable}>
        <thead>
          <tr>
            <th>{dataObject.configData.label_table_left}</th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td></td>
            <td>
              <span className={styles.portafolio}>
                {labels.portfolio1}
              </span>
            </td>
            <td>
              <span className={styles.portafolio}>
                {labels.portfolio2}
              </span>
            </td>
          </tr>
          {dataObject.data.map((row, index) => {
            const displayLabel = dataObject.configData.rows
              ? dataObject.configData.rows[row.label] || row.label
              : row.label;

            // Find the corresponding row in dataObject2
            const row2 = dataObject2.data.find(
              (r) => r.label === row.label,
            ) || { weight: 0 };

            return (
              <tr key={index}>
                <td>
                  <div className={styles.tableSimpleTdContainer}>
                    <div className={styles.tableSimpleTd}>
                      <span className={styles.tableValues}>{displayLabel}</span>
                    </div>
                  </div>
                </td>
                <td className={styles.tableLine}>
                  <span className={styles.tableValues}>
                    {formatItalianNumber(row.weight)}
                  </span>
                </td>
                <td className={styles.tableNoLine}>
                  <span className={styles.tableValues2}>
                    {formatItalianNumber(row2.weight)}
                  </span>
                </td>
              </tr>
            );
          })}
          <tr>
            <td>
              <div className={styles.totalCopy}>{t("portfolio.totale")}</div>
            </td>
            <td className={styles.tableLine}>
              <span className={styles.totalCopy}>{total1}</span>
            </td>
            <td className={styles.tableNoLine}>
              <span className={styles.totalCopy}>{total2}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default FinecoTableCompare;
